import angular from 'angular';
import {SelectionMenuComponent} from './selection-menu.component';

export default angular.module('slViz.selectionMenuModule', [])
    .component('selectionMenu', SelectionMenuComponent)
    .name;



// WEBPACK FOOTER //
// ./src/js/components/selection-menu/index.js